import qsa from 'dom-helpers/querySelectorAll';

export default doc => {
  try {
    loadInstagramScript(doc);
  } catch (e) {}
};

function loadInstagramScript(doc) {
  const $el = qsa(doc, '.instagram-media');
  if ($el.length === 0) {
    return;
  }

  const instagramScript = document.createElement('script');
  const instagramScriptEl = document.getElementsByTagName('script')[0];

  instagramScript.async = true;
  instagramScript.src = '//www.instagram.com/embed.js';
  instagramScript.charset = 'UTF-8';
  instagramScriptEl.parentNode.insertBefore(instagramScript, instagramScriptEl);
}
